export default __webpack_public_path__ + "static/media/ic_maps.8669baff.svg";